// extracted by mini-css-extract-plugin
export default {"faq":"SectionFAQ_faq__d8X2k"};